'use client'

import styles from './index.module.scss'

type LockedPaymentProps = {
  title: string
  message: string
}

export default function LockedPayment({ title, message }: LockedPaymentProps) {
  return (
    <div className={styles.locked}>
      <LockIcon />
      <span className={styles.title}>{title}</span>
      <span className={styles.message}>{message}</span>
    </div>
  )
}

function LockIcon() {
  return (
    <svg
      width="28"
      height="28"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={styles.icon}
    >
      <rect x="3" y="11" width="18" height="11" rx="2" stroke="currentColor" strokeWidth="1.7" />
      <path
        d="M7 11V7a5 5 0 0 1 10 0v4"
        stroke="currentColor"
        strokeWidth="1.7"
        strokeLinecap="round"
      />
    </svg>
  )
}
